import { useTranslation } from 'react-i18next'
import SiteLayout from '@/components/feature/SiteLayout'
import PageHeader from '@/components/feature/PageHeader'
import GallerySeo from '@/components/feature/GallerySeo'
import GallerySection from '@/components/feature/sections/GallerySection'
import CtaBand from '@/components/feature/CtaBand'

export default function Gallery() {
  const { t } = useTranslation()

  return (
    <SiteLayout>
      <GallerySeo />
      <PageHeader
        breadcrumb={t('pages.gallery.breadcrumb')}
        label={t('pages.gallery.label')}
        title={t('pages.gallery.title')}
        description={t('pages.gallery.description')}
        image="https://readdy.ai/api/search-image?query=cinematic%20collage%20gallery%20wall%20of%20warm%20wedding%20and%20portrait%20photographs%2C%20golden%20ambient%20lighting%2C%20deep%20brown%20and%20amber%20tones%2C%20artistic%20studio%20interior%2C%20premium%20editorial%20atmosphere&width=1920&height=900&seq=shabi-hdr-gallery&orientation=landscape"
        imageAlt="Portfolio wall of wedding and portrait photographs by Shabi Media"
      />
      <GallerySection />
      <CtaBand
        eyebrow={t('cta.gallery.eyebrow')}
        title={t('cta.gallery.title')}
        description={t('cta.gallery.description')}
      />
    </SiteLayout>
  )
}